const ISO_RE = /^\d{4}-\d{2}-\d{2}$/;

// Spätestes Datum sichtbarer Planungsnotizen (show_in_planner) – oder "" falls keins.
// exemptRefs: Set von auto_ref-Werten, deren Notizen das Projektende NICHT verlängern dürfen
// (Zusatzrechnungen, Servicevertrag-Header, Servicevertragsjahre).
export function latestVisibleNoteDate(notes, exemptRefs) {
  let latest = "";
  const exempt = exemptRefs instanceof Set ? exemptRefs : new Set(exemptRefs || []);
  for (const n of Array.isArray(notes) ? notes : []) {
    if (!n?.show_in_planner || !ISO_RE.test(n.date || "")) continue;
    // Notizen aus Zusatzrechnungen/Serviceverträgen verlängern das Ende nie.
    if (n.auto_ref && exempt.has(n.auto_ref)) continue;
    if (n.date > latest) latest = n.date;
  }
  return latest;
}

// Projektende nie verkürzen, aber auf den spätesten erlaubten sichtbaren Termin verlängern.
export function extendEndByVisibleNotes(endDate, notes, exemptRefs) {
  const latest = latestVisibleNoteDate(notes, exemptRefs);
  return latest && latest > (endDate || "") ? latest : endDate;
}

// Sammelt auto_ref-Werte aus Zahlungsarten, die das Projektende NICHT verlängern dürfen:
// Zusatzrechnungen, Servicevertrag-Header und Servicevertragsjahre.
// Standardzahlungen (payments[0..2]) sind bewusst NICHT enthalten.
export function buildExemptRefs(form) {
  const refs = new Set();
  for (const p of Array.isArray(form?.extra_payments) ? form.extra_payments : []) {
    if (p?.ref) refs.add(p.ref);
  }
  if (form?.service_contract?.ref) refs.add(form.service_contract.ref);
  for (const p of Array.isArray(form?.service_contract_entries) ? form.service_contract_entries : []) {
    if (p?.ref) refs.add(p.ref);
  }
  return refs;
}
